import moment from 'moment';
import {parseHourMinute} from '@utils/eventTimeFields';
import {firestore, FieldValue, functions} from '@src/db';
import {eventHub} from '@src/eventHub';
import {authComputed} from '@store/helpers';
import * as Workspace from '@common/Workspace';
import store from '@store';
import i18n from '@src/plugins/i18n';
const {translateDb, i18nConfig, languages} = require('@i18n');
const StringUtils = require('@common/StringUtils');
const status = require('@common/status');
const _ = require('lodash');
import {FcmLocalStorage} from '@utils/FcmLocalStorage';
import {getNewSequential, getNewSequentialMulti, SequentialExhaustedError, MAX_TRIES as SEQUENTIAL_MAX_TRIES} from '@services/Sequentail';

const version = `${process.env.VUE_APP_VERSION} (${process.env.VUE_APP_VERSION_NUMBER}) (${process.env.appConfig?.branchName})`;

export default {
  install(Vue, options) {
    /*
    Vue.mixin({
      beforeDestroy: function () {
        console.log('unsubscribe function', Vue.prototype.$fcmUnsubscriber);
        // for(let us of Vue.prototype.$fcmUnsubscriber) {
        //   if(typeof us === 'function') {
        //     us();
        //   }
        // }
      //  Vue.prototype.$fcmUnsubscriber = [];
      }
    });
    Vue.prototype.$fcmUnsubscriber = [];
    */

    /*
    if(typeof window!=='undefined' && window.visualViewport) {
      const listener = () => {
        const MIN_KEYBOARD_HEIGHT = 300
        const isMobile = window.innerWidth < 768
        const isKeyboardOpen = isMobile && window.innerHeight<768
          && window.screen.height - MIN_KEYBOARD_HEIGHT > window.visualViewport.height;
      }
      window.visualViewport.addEventListener('resize', listener);
    }
     */

    Vue.mixin({
      computed: {
        ...authComputed,
        $isDark: function() {
          return this.$vuetify.theme.dark;
        },
      }
    });

    // {{tr.date | jwZeroFill(5)}}
    Vue.filter('jwZeroFill', function(value, length=12) {
      if(!value) value = '';
      return value.toString().padStart(length, '0');
    });

    // {{tr.date | jwToDate}}
    // {{tr.date | jwToDate('DD MM YYYY')}}
    Vue.filter('jwToDate', function(value, format='') {
      if(!format) {
        format = i18n.t('format.date');
      }
      if(typeof value ==='string') {
        const v = moment(value);
        if(v.isValid()) {
          return v.format(format);
        }
      }
      if(typeof value?.toDate==='function') {
        const v = moment(value.toDate());
        if(v.isValid()) {
          return v.format(format);
        }
      }
      return '';
    });

    Vue.prototype.$eventHub = eventHub; // Global event bus

    Vue.prototype.$jwGetDate = function(value, format) {
      if(!format) {
        format = i18n.t('format.date');
      }
      if(typeof value?.toDate==='function') {
        const v = moment(value.toDate());
        if(v.isValid()) {
          return v.format(format);
        }
      }
      const v = moment(value);
      if(v.isValid()) {
        return v.format(format);
      }
      return '';
    };

    Vue.prototype.$trdb = function(obj) {
      if(this.$i18n && this.$i18n.locale) {
        const t = translateDb(this.$i18n.locale, obj);
        if(t) {
          return t;
        }
      }
      return translateDb('pt-BR', obj);
    };

    Vue.prototype.$trdbLocale = function() {
      if(this.$i18n && this.$i18n.locale) {
        return (languages[this.$i18n.locale] || {}).database;
      }
      return (languages[i18nConfig.fallbackLocale] || {}).database;
    };
    Vue.prototype.$dateFormat = function(d, format='format.date') {
      if (!d) {
        return '';
      }
      if (format.includes('format')) {
        format = i18n.t(format);
      }
      let _d = null;
      if (d instanceof moment) {
        _d = d;
      }
      else if (typeof d?.toDate === 'function') {
        _d = moment(d.toDate());
      }
      else {
        _d = moment(d);
      }
      if (_d.isValid()) {
        return _d.format(format);
      }
      return '';
    };
    Vue.prototype.$dateFormatBind = function(format='format.date') {
      return (d) => {
        return Vue.prototype.$dateFormat(d, format);
      };
    };

    Vue.prototype.$yesNoByBoolean = function(value) {
      return i18n.t('all.'+(value?'yes':'no'));
    };

    /**
     * @param {string|Object=} arg
     * @param {string} [arg.title=''] arg.title
     * @param {string} [arg.text=''] arg.text
     * @param {number} [arg.timer=2500] arg.timer
     */
    Vue.prototype.$showMsg = function(arg) {
      let {title='', text=null, timer=2500} = arg || {};
      if(typeof arg==='string') {
        title = arg;
      }
      this.$swal({
        toast: true,
        position: 'top-end',
        icon: 'success',
        title: title,
        text: text,
        showConfirmButton: false,
        timer: timer
      });
    };

    /**
     * @param {string|Object=} arg
     * @param {string} [arg.title=''] arg.title
     * @param {string} [arg.text=''] arg.text
     * @param {number} [arg.timer=3500] arg.timer
     */
    Vue.prototype.$showWarning = function(arg) {
      let {title='', text=null, timer=3500} = arg || {};

      if(typeof arg==='string') {
        title = this.$t('form.error.warning');
        text = arg;
      }

      if(!title) {
        title = this.$t('form.error.warning');
      }

      this.$swal({
        toast: true,
        position: 'top-end',
        icon: 'warning',
        title: title ,
        text: text,
        showConfirmButton: false,
        timer: timer,
        customClass: {
          popup: 'customPopup warningShadow',
          title: 'customTitle',
          content: 'customContent'
        }
      });
    };

    /**
     * @param {string|Object=} arg
     * @param {string} [arg.title=''] arg.title
     * @param {string} [arg.text=''] arg.text
     * @param {number} [arg.timer=2500] arg.timer
     */
    Vue.prototype.$showSuccess = function(arg) {
      let {title='', text=null, timer=2500} = arg || {};

      if(!title && !text) {
        title = this.$t('form.onlySuccess');
        text = this.$t('form.updateSuccess');
      }

      if(typeof arg==='string') {
        title = this.$t('form.onlySuccess');
        text = arg;
      }

      if(!title) {
        title = this.$t('form.onlySuccess');
      }

      this.$swal({
        toast: true,
        position: 'top-end',
        icon: 'success',
        title: title ,
        text: text,
        showConfirmButton: false,
        timer: timer,
        customClass: {
          popup: 'customPopup sucessShadow',
          title: 'customTitle',
          content: 'customContent'
        }
      });
    };

    /**
     * @param {string|Object=} arg
     * @param {string} [arg.title=''] arg.title
     * @param {string} [arg.text=''] arg.text
     * @param {number} [arg.timer=4500] arg.timer
     */
    Vue.prototype.$showError = function(arg) {
      let {title='', text=null, timer=4500} = arg || {};

      if(!title && !text) {
        title = this.$t('form.error.error');
        text = this.$t('form.error.update');
      }

      if(typeof arg==='string') {
        title = this.$t('form.error.error');
        text = arg;
      }
      if(!title) {
        title = this.$t('form.error.error');
      }

      this.$swal({
        toast: true,
        position: 'top-end',
        icon: 'error',
        title: title,
        text: text,
        showConfirmButton: false,
        timer: timer,
        customClass: {
          popup: 'customPopup errorShadow',
          title: 'customTitle',
          content: 'customContent'
        }
      });
    };

    /**
     *
     * @param title
     * @param text
     * @param confirmButtonText
     * @param cancelButtonText
     * @returns {Promise<boolean>}
     */
    Vue.prototype.$showConfirm = async function({title='', text=null, html=null, confirmButtonText = null, cancelButtonText = null, showCancelButton = true}={}) {
      if(!title && !text && !html) {
        title = this.$t('form.confirmQuestion');
      }
      // SweetAlert2: a opção `html` renderiza HTML; `text` é texto puro (escapado).
      // `html` aceita string (o próprio conteúdo) ou flag booleana (usa o `text` como HTML).
      // ⚠️ Conteúdo HTML não é sanitizado — escape valores dinâmicos não confiáveis no caller.
      const htmlContent = typeof html === 'string' ? html : (html === true ? text : null);
      const result = await this.$swal({
        title: title,
        ...(htmlContent != null ? {html: htmlContent} : {text: text}),
        showCancelButton: showCancelButton,
        confirmButtonText: confirmButtonText || this.$t('form.confirmQuestionYes'),
        cancelButtonText: cancelButtonText || this.$t('form.confirmQuestionCancel'),
        customClass:{
          container: 'modalContainer',
          confirmButton: 'btnConfirm',
          cancelButton: 'btnCancel'
        },
        buttonsStyling: false
      });
      return !!result.value;
    };


    Vue.prototype.$showPrompt = async function({title='', text=null, input='text',
      confirmButtonText=this.$t('form.confirmQuestionYes'),
      cancelButtonText=this.$t('form.confirmQuestionCancel'),
      inputAttributes = {},
      inputValue='',
      required=false,
      textMessageOnRequired=''

    }={}) {
      if(!title && !text) {
        title = this.$t('form.promptQuestion');
      }
      const result = await this.$swal.fire({
        title: title,
        text: text,
        input: input,
        inputAttributes: inputAttributes,
        showCancelButton: true,
        confirmButtonText: confirmButtonText,
        cancelButtonText: cancelButtonText,
        inputValue: inputValue,
        customClass:{
          container: 'modalContainer',
          confirmButton: 'btnConfirm',
          cancelButton: 'btnCancel'
        },
        inputValidator: ()=>{return false;},
        preConfirm: (textConfirm) => {
          if (required && !textConfirm) {
            this.$swal.showValidationMessage(textMessageOnRequired || this.$t('form.answerRequired'));
          }
        }
      });
      // console.log('result', result);
      if(result.isConfirmed) {
        return result.value;
      }
      return false;
    };


    Vue.prototype.$newId = function(table='id') {
      return firestore.collection(table).doc().id;
    };
    // Old, chamando uma cloud que é muito lenta
    // Vue.prototype.$newSequenceCall = async function(id, table='', field='', extra=null) {
    //   try {
    //     return (await functions.httpsCallable('sequential-getNewSequential')({
    //       ...extra,
    //       id, table, field
    //     }))?.data?.data || 0;
    //   } catch(err) {
    //     console.error('Error $newSequence', err);
    //     return 0;
    //   }
    // };

    // Esgotar as tentativas (contador atrás da coleção) LANÇA `SequentialExhaustedError` em vez
    // de devolver 0: o fallback pela cloud roda o mesmo laço sobre a mesma coleção e esgotaria
    // igual, e devolver 0 era o que fazia o caller gravar `code: 0` (#1243). Erro de outra
    // natureza (rede, RTDB) segue para o fallback como antes.
    Vue.prototype.$newSequence = async function(id, table='', field='', extra=null) {
      const query = {...extra, id, table, field};
      try {
        return (await getNewSequential(query)) || 0;
      } catch(err) {
        if(err instanceof SequentialExhaustedError) {
          throw err;
        }
        console.error('Error $newSequence iniciando fallBack', err);
        try {
          const res = await functions.httpsCallable('sequential-getNewSequential')(query);
          if(res?.data?.errorCode === status.apiErrorCode.exhaustedAttempts) {
            throw new SequentialExhaustedError(query, SEQUENTIAL_MAX_TRIES);
          }
          return res?.data?.data || 0;
        } catch(err) {
          if(err instanceof SequentialExhaustedError) {
            throw err;
          }
          console.error('Error $newSequence Call', err);
          return 0;
        }
      }
    };
    Vue.prototype.$newSequenceMulti = async function(id, table='', field='', extra=null, qtd) {
      try {
        return (await getNewSequentialMulti({
          ...extra,
          id, table, field, qtd
        })) || 0;
      } catch(err) {
        if(err instanceof SequentialExhaustedError) {
          throw err;
        }
        console.error('Error $newSequence', err);
        return 0;
      }
    };

    Vue.prototype.$metaInfo = function(isNew=false, isAdmin=false) {
      let metaInfo = {};
      if(!isAdmin) {
        isAdmin = this.currentWorkspace===Workspace.name.ADMIN;
      }
      if (isNew) {
        metaInfo = {
          createdAt: FieldValue.serverTimestamp(),
          createdBy: this.currentUser?.id || '',
          createdByName: this.currentUser?.name || '',
          createdEnv: status.source.WEB,
          createdVersion: version,
        };
      }
      metaInfo = {
        ...metaInfo,
        updatedAt: FieldValue.serverTimestamp(),
        updatedBy: this.currentUser?.id || '',
        updatedByName: this.currentUser?.name || '',
        updatedByCompanyId: this.currentUser?._companyId || '',
        updatedEnv: status.source.WEB,
        updatedByAdmin: isAdmin,
        updatedVersion: version,
      };
      return metaInfo;
    };

    Vue.prototype.$fcmGetDark = function() {
      const isDark = typeof window!=='undefined'?FcmLocalStorage.getItem('darkMode'):null;
      if(isDark==='true') {
        return true;
      }
      if(isDark==='false') {
        return false;
      }
      return true; // Setando dark mode como default
      // isDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
      // return !!isDark;
    };

    Vue.prototype.$fcmSetDark = function(isDark) {
      FcmLocalStorage.setItem('darkMode', isDark?'true':'false');
      if(this.$vuetify && this.$vuetify.theme) {
        if(this.$vuetify.theme.dark!==isDark) {
          this.$vuetify.theme.dark = isDark;
        }
      }
    };

    Vue.prototype.$rules = {
      requiredWithDash: value => !!String(value) || i18n.t('form.error.required'),
      required: value => !!value || i18n.t('form.error.required'),
      requiredItemInArray: value => (value?.length > 0) || i18n.t('form.error.required'),
      counter: value => value.length <= 20 || i18n.t('form.error.maxLength'),
      minLength: value => {
        if(value && value.length > 0 && value.length < 3) {
          return i18n.t('form.error.minLengthRequired') + ' 3';
        } else {
          return true;
        }
      },
      minLengthCustom: min => {
        return value => {
          if(value?.length < min) {
            return i18n.t('form.error.minLengthRequired') + ' '+min;
          } else {
            return true;
          }
        };
      },
      maxLength: max => {
        return value => {
          if(value?.length > max) {
            return i18n.t('form.error.maxLengthRequired') + ' '+max;
          } else {
            return true;
          }
        };
      },
      countHours: value => {
        if(value && value.length > 0 && value.length < 5) {
          return i18n.t('form.error.invalidAmountHours');
        } else {
          return true;
        }
      } ,
      counterCNPJ: value => {
        if(value && value.length > 0 && value.length < 18) {
          return i18n.t('form.error.minLength') + ' ' + value.length+'/18';
        } else {
          return true;
        }
      } ,
      email: value => {
        if(!value) {return true;}
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || i18n.t('form.error.email');
      },
      numberDotComma: value => {
        const pattern = /^[0-9.,]*$/;
        return pattern.test(value) || i18n.t('form.error.invalidValue');
      },
      number: value => {
        const pattern = /^[0-9]*$/;
        return pattern.test(value) || i18n.t('form.error.justNumbers');
      },
      numberAndDash: value => {
        const pattern = /^[0-9-]*$/;
        return pattern.test(value) || i18n.t('form.error.justNumbers');
      },
      positive: value => {
        return (!value || value >=0) ||  i18n.t('form.error.needPositive');
      },
      hourMinute: (value)=>{
        if (!value) {
          return true;
        }
        if (parseHourMinute(value)) {
          return true;
        }
        return i18n.t('form.error.invalidHour');
      },
      cpf: (value)=>{
        if (!value) {
          return true;
        }
        if(StringUtils.validateCpf(value)) {
          return true;
        }
        return i18n.t('form.error.invalidCPF');
      },
      percent: value => {
        // if(value.includes(',')) {
        //   if(! (!value || value >=0)) {
        //     return i18n.t('form.error.needPositive');
        //   }
        // }
        const pattern = /^[0-9]{1,3}(,|.)[0-9]{2}$/;
        return pattern.test(value) || i18n.t('form.error.invalidValue');
      },
      minRangeRules: [
        value => !!value || 'Digite o número mínimo',
        value => (value && value >= 1 && value <= 20) || 'O valor precisa estar entre 1 e 20',
      ],
      maxRangeRules: [
        value => !!value || 'Digite o número máximo',
        value => (value && value <= 20 && value >= 1)  || 'O valor precisa estar entre 1 e 20',
      ],
    };

    /**
     * @deprecated
     */
    Vue.prototype.$validateRules = function() {
      return Vue.prototype.$rules;
    };
    Vue.prototype.$deburr = function(txt) {
      return _.deburr(txt|| '').toLowerCase().trim();
    };

    // Obs: extends Error não funciona com o Babel
    Vue.prototype.JwGetError = function(message, code='') {
      const err = new Error(message);
      err.code = code;
      return err;
    };
    Vue.prototype.$money2Float = function(num) {
      if (num === '') {
        num = 0;
      } else {
        num = num.replace('R$ ', '');
        num = num.replace(/\./g, '');
        num = num.replace(',', '.');
        num = parseFloat(num);
      }
      return num;
    };

    Vue.prototype.$cpfExist =  async function(cpf, id, table) {
      if(!cpf) {
        return 'cpfInvalid';
      }
      if(StringUtils.validateCpf(cpf)!==true) {
        return 'cpfInvalid';
      }
      cpf = cpf.replace(/[.-]/g, '');
      if (cpf.length === 11) {
        try {
          const doc = await firestore.collection(table).where('cpf', '==', cpf).get();
          if(!doc.empty) {
            let find = false;
            if(id) {
              doc.forEach((obj)=>{
                if(obj.id===id) {
                  find = id;
                }
              });
            }
            if(!find) {
              return 'cpfExist';
            }
          }
          return 'cpfOk';
        } catch(error) {
          console.error('$cpfExist:', error);
          return 'cpfError';
        }
      }
      return 'cpfInvalid';
    };

    Vue.prototype.$sortByTimeStamp = function(items, field) {
      return items.sort((a, b) => {
        if(a?.[field] && b?.[field]) {
          return b?.[field]?.seconds - a?.[field]?.seconds;
        }
        else if(a?.[field]) {
          return 1;
        }
        else if(b?.[field]) {
          return -1;
        }
        else {
          return 0;
        }
      });
    };

    Vue.prototype.$fcmClearAndReload = function() {
      if(window.navigator && navigator.serviceWorker) {
        navigator.serviceWorker.getRegistrations()
          .then(function(registrations) {
            for(const registration of registrations) {
              registration.unregister?.();
            }
            window.location.reload();
          });
      }
      else {
        window.location.reload();
      }
    };

    Vue.prototype.$AuthActions = status.AuthActions;
    Vue.prototype.$companyModulesValidate = async function(module, action, displayMsg= false, actionOwn=null, id=null) {
      if(await store.dispatch('auth/authCompanyModulesValidate', {module, action})) {
        return true;
      }
      if(actionOwn) {
        const hasOwn = await store.dispatch('auth/authCompanyModulesValidate', {module, action: actionOwn});
        if(actionOwn && !id && hasOwn) {
          return true;
        }
        if(actionOwn && id && hasOwn && this.currentUser?.id===id) {
          return true;
        }
      }
      displayMsg && this.$showError({
        title: `${this.$t('router.accessDenied')} ${this.$t('router.modules.'+module)}: ${this.$t('router.actions.'+action)}`,
        timer: 5500,
      });
      // console.log('DebugValidate');
      return false;
    };

    Vue.prototype.moment = moment;
    Vue.prototype._ = _;
  }
};
